import profileImg from '../assets/crop-image.jpg';
import {
    FaGithub,
    FaLinkedin,
    FaDev,
    FaTwitter,
  } from 'react-icons/fa';
import About from "./About";
import Skills from "./Skills";
import Testimonials from "./Testimonials";
import HighlightProjects from "./HighlightProjects";
import Contact from "./Contact";

const Home = () => {
  return (
    <><div id='home' className='w-full bg-[#0a192f] dark:bg-gray-100 z-10'>
          {/* Container */}
          <div className='relative md:flex flex-row justify-between md:pt-40  pt-24 px-1 md:px-16 max-w-8xl mx-auto'>
              <div className='max-w-[950px] px-4 flex flex-col justify-center '>
                  <p className='text-yellow-600 text-2xl dark:text-gray-800'>Hi,</p>
                  <h1 className='md:text-4xl text-5xl mb-4 font-bold text-[#ccd6f6] dark:text-gray-800'>
                      I'm Shivam,
                  </h1>
                  <h2 className='text-2xl sm:text-3xl mb-4 font-bold text-[#8892b0] dark:text-gray-800'>
                      Frontend Developer @ <a href='https://twimbit.com' alt='twimbit' class='hover:underline'>twimbit</a>
                  </h2>
                  <div className='flex w-full'>
                      <button className='text-white text-xs border-2 rounded-lg border-gray-600 px-2 py-2 my-2 flex items-center hover:bg-gray-700 hover:border-gray-300 dark:text-gray-800 dark:hover:text-gray-100 dark:hover:bg-gray-500 dark:hover:border-gray-900'>
                          <a href= 'Shivam-Resume.pdf' target='_blank' className="cursor-pointer"> Resume</a>
                  </button>
                  <div class="lg:hidden inline-flex text-2xl space-x-3 ml-8 mt-2">
                      <a href="https://www.linkedin.com/in/shivam-webdev">
                          <FaLinkedin className='text-blue-500' size={30} />
                      </a>
                      <a href="https://github.com/Shivamk99">
                          <FaGithub size={30} className='text-white dark:text-gray-800' />
                      </a>
                      <a href="https://twitter.com/Shivamk_99">
                          <FaTwitter size={30} className='text-blue-500' />
                      </a>
                      <a href="https://dev.to/smileyshivam">
                          <FaDev size={30} className='text-red-300' />
                      </a>
                  </div>
              </div>
          </div>
          <div className='flex flex-shrink-0 justify-center sp:pb-0 md:pb-0 items-center'>
              <img src={profileImg} alt='Profile Image' className="rounded-full object-cover w-80 h-80 m-4" />
          </div>
      </div><About /><Skills /><HighlightProjects /><Testimonials /><Contact />
    </div></>
  );
};

export default Home;
